
export const caseStudies = [
  {
    id: 'kampala-serena-hotel',
    title: 'Kampala Serena Hotel — Full Brand Refresh',
    client: 'Kampala Serena Hotel',
    category: 'Branding',
    location: 'Kampala, Uganda',
    flag: '🇺🇬',
    year: '2024',
    duration: '4 Months',
    heroImage: 'https://readdy.ai/api/search-image?query=Luxury%20five%20star%20hotel%20exterior%20at%20golden%20hour%20with%20warm%20ambient%20lighting%20elegant%20architecture%20modern%20African%20hospitality%20premium%20photography%20wide%20angle%20dramatic%20sky%20Kampala%20Uganda%20cityscape%20background%20professional%20commercial%20photography&width=1200&height=700&seq=case-serena-hero-001&orientation=landscape',
    thumbnail: 'https://asili.co.ug/visuals/assets/img/image-3.jpg.jpeg',
    challenge: 'Kampala Serena Hotel needed to modernize its brand identity to appeal to a younger generation of business travelers while retaining the trust and prestige built over decades. Their existing visual identity felt dated compared to emerging boutique competitors in the East African hospitality market.',
    solution: 'We conducted a comprehensive brand audit across 14 touchpoints, developed a refreshed visual identity system that honored the heritage while introducing contemporary design elements. The new brand architecture included updated typography, a refined color palette, and a modular design system for both digital and physical applications.',
    results: [
      { metric: '40%', label: 'Increase in Direct Bookings' },
      { metric: '2.8M', label: 'Social Media Impressions' },
      { metric: '95%', label: 'Brand Consistency Score' },
      { metric: '12', label: 'Touchpoints Redesigned' },
    ],
    services: ['Brand Audit', 'Visual Identity', 'Digital Campaign', 'Print Collateral'],
    testimonial: {
      quote: 'Asili Visuals completely transformed our brand presence. Their strategic approach resulted in a 40% increase in direct bookings within six months.',
      author: 'Grace Nakamya',
      role: 'Marketing Director',
    },
    gallery: [
      'https://asili.co.ug/visuals/assets/img/image-3.jpg.jpeg',
      'https://asili.co.ug/visuals/assets/img/image-4.jpg.jpeg',
      'https://asili.co.ug/visuals/assets/img/image-5.jpg.jpeg',
    ],
  },
  {
    id: 'savannah-logistics',
    title: 'Savannah Logistics — Fleet & Outdoor Campaign',
    client: 'Savannah Logistics Ltd',
    category: 'Outdoor',
    location: 'Nairobi, Kenya',
    flag: '🇰🇪',
    year: '2024',
    duration: '3 Months',
    heroImage: 'https://readdy.ai/api/search-image?query=Professional%20fleet%20of%20branded%20logistics%20trucks%20on%20major%20East%20African%20highway%20dramatic%20wide%20angle%20shot%20warm%20golden%20hour%20lighting%20modern%20vehicle%20branding%20corporate%20fleet%20management%20premium%20commercial%20photography%20Nairobi%20Kenya%20landscape&width=1200&height=700&seq=case-savannah-hero-001&orientation=landscape',
    thumbnail: 'https://asili.co.ug/visuals/assets/img/image-6.jpg.jpeg',
    challenge: 'Savannah Logistics operated a fleet of 85 vehicles across the Northern Corridor but had zero brand visibility. Their trucks were unmarked, and competitors with branded fleets were winning contracts based on perceived professionalism and scale.',
    solution: 'We designed a bold, high-visibility fleet branding system with reflective elements for night visibility. Simultaneously, we launched a billboard campaign across 6 strategic locations on the Nairobi-Kampala-Mombasa corridor, creating a unified brand presence that signaled scale and reliability.',
    results: [
      { metric: '3x', label: 'Brand Recognition Growth' },
      { metric: '85', label: 'Vehicles Branded' },
      { metric: '6', label: 'Billboard Locations' },
      { metric: '22%', label: 'New Contract Increase' },
    ],
    services: ['Vehicle Branding', 'Billboard Design', 'Outdoor Advertising', 'Brand Strategy'],
    testimonial: {
      quote: 'From our fleet branding to billboard campaigns across the Northern Corridor, Asili delivered with precision and creativity. Our brand recognition tripled.',
      author: 'James Ochieng',
      role: 'CEO',
    },
    gallery: [
      'https://asili.co.ug/visuals/assets/img/image-6.jpg.jpeg',
      'https://asili.co.ug/visuals/assets/img/image-7.jpg.jpeg',
      'https://asili.co.ug/visuals/assets/img/reflectors.jpg.jpeg',
    ],
  },
  {
    id: 'tanzania-investment-centre',
    title: 'Tanzania Investment Centre — Corporate Documentary',
    client: 'Tanzania Investment Centre',
    category: 'Film',
    location: 'Dar es Salaam, Tanzania',
    flag: '🇹🇿',
    year: '2024',
    duration: '6 Weeks',
    heroImage: 'https://readdy.ai/api/search-image?query=Professional%20film%20production%20crew%20shooting%20corporate%20documentary%20in%20modern%20African%20government%20building%20cinematic%20camera%20equipment%20dramatic%20lighting%20behind%20the%20scenes%20premium%20photography%20Dar%20es%20Salaam%20Tanzania%20urban%20setting&width=1200&height=700&seq=case-tic-hero-001&orientation=landscape',
    thumbnail: 'https://asili.co.ug/visuals/assets/img/image-8.jpg.jpeg',
    challenge: 'The Tanzania Investment Centre needed a compelling corporate documentary to attract international investors. Previous attempts at video content lacked cinematic quality and failed to communicate the strategic value proposition of investing in Tanzania.',
    solution: 'We produced a 12-minute cinematic documentary featuring interviews with key stakeholders, aerial footage of investment zones, and data-driven storytelling. The film was complemented by a PR strategy that secured placements in 8 international business publications.',
    results: [
      { metric: '500K+', label: 'Documentary Views' },
      { metric: '8', label: 'International Publications' },
      { metric: '15', label: 'Investor Inquiries Generated' },
      { metric: '12min', label: 'Cinematic Documentary' },
    ],
    services: ['Film Production', 'Scriptwriting', 'PR Strategy', 'Media Placement'],
    testimonial: {
      quote: 'The corporate documentary Asili produced was exceptional. It captured our mission with cinematic quality that resonated with international investors.',
      author: 'Amina Bashir',
      role: 'Communications Manager',
    },
    gallery: [
      'https://asili.co.ug/visuals/assets/img/image-8.jpg.jpeg',
      'https://asili.co.ug/visuals/assets/img/image-9.jpg.jpeg',
      'https://asili.co.ug/visuals/assets/img/image-10.jpg.jpeg',
    ],
  },
  {
    id: 'pearl-agro-industries',
    title: 'Pearl Agro Industries — Complete Brand Build',
    client: 'Pearl Agro Industries',
    category: 'Branding',
    location: 'Kampala, Uganda',
    flag: '🇺🇬',
    year: '2023',
    duration: '5 Months',
    heroImage: 'https://readdy.ai/api/search-image?query=Modern%20agricultural%20processing%20facility%20with%20branded%20packaging%20products%20corporate%20identity%20design%20elements%20professional%20commercial%20photography%20warm%20natural%20lighting%20clean%20organized%20workspace%20Kampala%20Uganda%20agribusiness%20premium%20quality&width=1200&height=700&seq=case-pearl-hero-001&orientation=landscape',
    thumbnail: 'https://asili.co.ug/visuals/assets/img/image-10.jpg.jpeg',
    challenge: 'Pearl Agro Industries was a growing agricultural enterprise with 200 employees but zero brand infrastructure. They had no logo, no brand guidelines, no website, and their workforce wore mismatched clothing. They needed to look like the multinational they aspired to become.',
    solution: 'We built their entire brand ecosystem from scratch — logo design, comprehensive brand guidelines, a professional website, product packaging, and custom uniforms for their 200-person team. Every touchpoint was designed to communicate quality, reliability, and scale.',
    results: [
      { metric: '200+', label: 'Staff Uniformed' },
      { metric: '100%', label: 'Brand Consistency' },
      { metric: '5', label: 'Product Lines Packaged' },
      { metric: '3x', label: 'Revenue Growth in 1 Year' },
    ],
    services: ['Brand Development', 'Web Design', 'Packaging', 'Garment Manufacturing'],
    testimonial: {
      quote: 'Asili built our entire brand from the ground up. The consistency across every touchpoint has made us look like a multinational. Incredible attention to detail.',
      author: 'Patrick Mugisha',
      role: 'Founder & Managing Director',
    },
    gallery: [
      'https://asili.co.ug/visuals/assets/img/image-10.jpg.jpeg',
      'https://asili.co.ug/visuals/assets/img/NEWWWWCLO.jpg.jpeg',
      'https://asili.co.ug/visuals/assets/img/tdfav.jpg.jpeg',
    ],
  },
  {
    id: 'kigali-heights-mall',
    title: 'Kigali Heights Mall — Digital Transformation',
    client: 'Kigali Heights Mall',
    category: 'Digital',
    location: 'Kigali, Rwanda',
    flag: '🇷🇼',
    year: '2024',
    duration: '3 Months',
    heroImage: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20shopping%20mall%20interior%20with%20digital%20screens%20social%20media%20content%20displays%20contemporary%20retail%20environment%20warm%20ambient%20lighting%20premium%20commercial%20photography%20Kigali%20Rwanda%20African%20urban%20lifestyle%20elegant%20architecture&width=1200&height=700&seq=case-kigali-hero-001&orientation=landscape',
    thumbnail: 'https://asili.co.ug/visuals/assets/img/image-5.jpg.jpeg',
    challenge: 'Kigali Heights Mall had a strong physical presence but virtually no digital footprint. Their social media accounts were inactive, their website was outdated, and they were losing foot traffic to competitors who were engaging customers online with promotions and events.',
    solution: 'We redesigned their website, built a content calendar with 90 days of planned content, launched targeted social media campaigns, and implemented an SEO strategy focused on local search. We also created a digital loyalty program to bridge online engagement with in-store visits.',
    results: [
      { metric: '35%', label: 'Foot Traffic Increase' },
      { metric: '12K', label: 'New Social Followers' },
      { metric: '180%', label: 'Website Traffic Growth' },
      { metric: '90', label: 'Days of Content Planned' },
    ],
    services: ['Web Design', 'Social Media', 'SEO Strategy', 'Content Production'],
    testimonial: {
      quote: 'Their content strategy and social media management transformed our online presence. Foot traffic increased by 35% after their digital campaign launch.',
      author: 'Diane Uwimana',
      role: 'Head of Marketing',
    },
    gallery: [
      'https://asili.co.ug/visuals/assets/img/image-5.jpg.jpeg',
      'https://asili.co.ug/visuals/assets/img/image-4.jpg.jpeg',
      'https://asili.co.ug/visuals/assets/img/image-3.jpg.jpeg',
    ],
  },
  {
    id: 'juba-construction-group',
    title: 'Juba Construction Group — Corporate Rebrand',
    client: 'Juba Construction Group',
    category: 'Branding',
    location: 'Juba, South Sudan',
    flag: '🇸🇸',
    year: '2023',
    duration: '4 Months',
    heroImage: 'https://readdy.ai/api/search-image?query=Large%20scale%20construction%20site%20with%20branded%20safety%20equipment%20corporate%20identity%20on%20heavy%20machinery%20professional%20commercial%20photography%20warm%20golden%20hour%20lighting%20modern%20infrastructure%20development%20African%20urban%20construction%20premium%20quality&width=1200&height=700&seq=case-juba-hero-001&orientation=landscape',
    thumbnail: 'https://asili.co.ug/visuals/assets/img/reall td.jpg.jpeg',
    challenge: 'Juba Construction Group was competing for government contracts but their brand lacked the professionalism and credibility needed to win tenders. Their proposals looked amateur, their site presence was unbranded, and they had no corporate profile to present to decision-makers.',
    solution: 'We executed a full corporate rebrand including a new visual identity, professional company profile, branded safety gear and site signage, and a series of billboard placements in Juba. We also produced a capabilities brochure specifically designed for government tender submissions.',
    results: [
      { metric: '3', label: 'Government Contracts Won' },
      { metric: '100%', label: 'Site Branding Coverage' },
      { metric: '4', label: 'Billboard Placements' },
      { metric: '60%', label: 'Tender Win Rate Increase' },
    ],
    services: ['Corporate Rebrand', 'Print Production', 'Outdoor Advertising', 'Garment Branding'],
    testimonial: {
      quote: 'Working with Asili on our corporate rebrand was seamless. They delivered billboard designs, branded safety gear, and a company profile that won us three government contracts.',
      author: 'Samuel Lado',
      role: 'Director of Operations',
    },
    gallery: [
      'https://asili.co.ug/visuals/assets/img/reall td.jpg.jpeg',
      'https://asili.co.ug/visuals/assets/img/reflectors.jpg.jpeg',
      'https://asili.co.ug/visuals/assets/img/tdfav.jpg.jpeg',
    ],
  },
];

export const categories = ['All', 'Branding', 'Outdoor', 'Film', 'Digital'];
